import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '原版模件',
    type: 'ISRFREQ_BASMODULE',
}
